<template>
    <modal size="lg" @close="reset(); $emit('close')" ref="modal">
        <template v-slot:title>
            <h3 class="modal-title">Earnings Statement</h3>
        </template>

        <slot>
            <earnings-statement-view
                v-if="dataLoaded"
                :client="client"
                :employee="employee"
                :statement="earningsStatement"
                :result="earningsStatementResult"
                :work-locations="workLocations"
                :company-earning-types="companyEarningTypes"
                :ytd="ytd"
                :engine-io="engineIo"
                :show-ytd="true"
            />
        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">Done</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import ButtonRow from '@/components/ButtonRow'
import ModalMixin from '@/mixins/ModalMixin'
import EarningsStatementView from '@/pages/client/payroll/components/EarningsStatementView'

export default {
    components: { ButtonRow, EarningsStatementView },
    mixins: [ModalMixin],
    props: ['client', 'earningsStatementId'],
    emits: ['close'],
    data() {
        return {
            dataLoaded: false,
            earningsStatement: null,
            earningsStatementResult: null,
            companyEarningTypes: [],
            workLocations: [],
            ytd: null,
            employee: null,
            engineIo: null,  // superusers only
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/earnings-statements/${this.earningsStatementId}`)
                .then(resp => {
                    this.earningsStatement = resp.earnings_statement
                    this.employee = resp.employee
                    this.earningsStatementResult = resp.earnings_statement_result
                    this.companyEarningTypes = resp.company_earning_types
                    this.workLocations = resp.work_locations
                    this.ytd = resp.ytd
                    this.engineIo = resp.engine_io || null
                    this.dataLoaded = true
                    this.$store.dispatch('STOP_LOADING')
                })
                .catch(() => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError('Could not load earnings statement. Please refresh the page and try again.')
                })
        },
    },
}
</script>
